import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import InputField from '@axa-asia/emma-stylesheet/lib/components/Input/InputField';
import CountryTelephoneNumber from '@axa-asia/emma-stylesheet/lib/components/CountryTelephoneNumber/CountryTelephoneNumber';
import LoadingView from '../../../../components/LoadingView';
import EmmaErrorModal from '../../../../components/EmmaErrorModal';
import './style.scss';
import { goto } from '../../../../actions/historyActions';
import {
  submitResetUserName,
  changeCurTab,
  updateResetUserNameEmail,
  updateResetUserNameMobile,
} from '../../actions/customerResetUserNameAction';
import { sendOtp } from '../../actions/customerProfileVerifyAction';
import { getCustomerProfileUsenameConfig } from '../../selectors/customerProfileResetUsenameSelectors';
import { getSendOtpLoading } from '../../selectors/customerProfileVerifySelectors';
import { getCustomerProfileCurrentUpdateKey } from '../../selectors/customerProfileResetUNOrPWSelectors';
import { resolveLocalizedText } from '../../../../utils';
import {
  RESET_USER_NAME_EMAIL_TYPE,
  RESET_USER_NAME_MOBILE_TYPE,
  FEATURE_NAME_USER_NAME,
  VERIFY_SEND_EMAIL_OTP_DEFAULT_ERROR_CODE,
  VERIFY_SEND_MOBILE_OTP_DEFAULT_ERROR_CODE,
  RESET_USERNAME_EMAIL_FEATURE_ID,
  RESET_USERNAME_MOBILE_FEATURE_ID,
} from '../../constants/constants';
import { callBackErrorCodePage } from '../../utils';
import loadingIcon from '../../../../assets/images/loading-white.png';
import { ChangeContactView } from '../../components/ChangeContactView';
import browserHistory from '../../../../stores/browserHistory';
import { setNavigationBarTitle } from '../../../../utils/AppUtils';
import { t } from '../../../../locales';
import { EmmaTabs } from '@axa-asia/emma-stylesheet';

export interface CustomerResetUsenameContainerProps {
  title: string;
  desc: string;
  emailTabLabel: string;
  emailFormInputLabel: string;
  emailFormInputPlaceholder: string;
  emailFormInputButtonText: string;
  mobileTabLabel: string;
  mobileFormInputLabel: string;
  mobileFormInputPlaceholder: string;
  mobileFormInputButtonText: string;
  emailErrorMsg: string;
  mobileErrorMsg: string;
  emailErrorEmptyMsg: string;
  isSubmitLoading: boolean;
  curUpdateKey: string;
  onSubmitResetUserName: (params: any) => void;
  onSendOtp: (params: any) => void;
  onUpdateResetUserNameEmail: (params: string) => void;
  onUpdateResetUserNameMobile: (params: string) => void;
  onChangeCurTab: (params: string) => void;
  resetUsernameStepContext: any;
}

export interface CustomerResetUsenameContainerState {
  activedTab: string;
  emailValue: string;
  isEmailCorrect: boolean;
  isEmailEmpty: boolean;
  countryValue: string;
  mobileValue: string;
  isMobileCorrect: boolean;
}

export class CustomerResetUsenameContainer extends Component<
  CustomerResetUsenameContainerProps,
  CustomerResetUsenameContainerState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      activedTab: this.props.emailTabLabel,
      emailValue: '',
      isEmailCorrect: false,
      isEmailEmpty: false,
      countryValue: '',
      mobileValue: '',
      isMobileCorrect: false,
    };
  }

  componentDidMount() {
    const { curUpdateKey, title } = this.props;
    !curUpdateKey && goto('emma-customer-profile-resetusenameorpassword');
    this.changeUserNameCurTab();

    setNavigationBarTitle(title);
  }

  changeUserNameCurTab() {
    const { activedTab } = this.state;
    const { emailTabLabel, mobileTabLabel, onChangeCurTab } = this.props;
    if (emailTabLabel === activedTab) {
      onChangeCurTab(RESET_USER_NAME_EMAIL_TYPE);
    } else if (mobileTabLabel === activedTab) {
      onChangeCurTab(RESET_USER_NAME_MOBILE_TYPE);
    }
  }

  toggleTab = (tabKey: string) => {
    this.setState(
      {
        activedTab: tabKey,
      },
      () => {
        this.changeUserNameCurTab();
      },
    );
  };

  onEmailChange = (e: any) => {
    const { value, isCorrect, isEmpty } = e;
    this.setState({
      emailValue: value,
      isEmailCorrect: isCorrect,
      isEmailEmpty: isEmpty,
    });
  };

  onMobilehange = (e: any) => {
    const { countryValue, value, isCorrect } = e;
    this.setState({
      countryValue: countryValue,
      mobileValue: value,
      isMobileCorrect: isCorrect,
    });
  };

  onSubmit = (type: string) => {
    const {
      onSendOtp,
      onUpdateResetUserNameEmail,
      onUpdateResetUserNameMobile,
    } = this.props;
    const { emailValue, countryValue, mobileValue } = this.state;
    const mobile = `${countryValue}${mobileValue}`;
    const featureName = FEATURE_NAME_USER_NAME;
    const callBack = () => {
      if (type === RESET_USER_NAME_EMAIL_TYPE) {
        onUpdateResetUserNameEmail(emailValue);
      } else if (type === RESET_USER_NAME_MOBILE_TYPE) {
        onUpdateResetUserNameMobile(mobile);
      }
      goto('emma-customer-profile-reset-verify');
    };
    const sendData =
      type === RESET_USER_NAME_EMAIL_TYPE
        ? {
            type,
            callBack,
            email: emailValue,
            mobile: null,
            countryCode: null,
            featureName,
            callBackErrorCodePage,
            defaultErrorCode: VERIFY_SEND_EMAIL_OTP_DEFAULT_ERROR_CODE,
            featureId: RESET_USERNAME_EMAIL_FEATURE_ID,
            userId: emailValue,
          }
        : type === RESET_USER_NAME_MOBILE_TYPE
        ? {
            type,
            callBack,
            email: null,
            countryCode: countryValue,
            mobile: mobileValue,
            featureName,
            callBackErrorCodePage,
            defaultErrorCode: VERIFY_SEND_MOBILE_OTP_DEFAULT_ERROR_CODE,
            featureId: RESET_USERNAME_MOBILE_FEATURE_ID,
            userId: mobile,
          }
        : null;
    sendData && onSendOtp(sendData);
  };

  onGoBack = () => {
    browserHistory.goBack();
  };

  render() {
    const { activedTab, isEmailEmpty, isEmailCorrect, isMobileCorrect } =
      this.state;
    const {
      title,
      desc,
      emailTabLabel,
      emailFormInputLabel,
      emailFormInputPlaceholder,
      emailFormInputButtonText,
      mobileTabLabel,
      mobileFormInputLabel,
      mobileFormInputPlaceholder,
      mobileFormInputButtonText,
      emailErrorMsg,
      mobileErrorMsg,
      emailErrorEmptyMsg,
      isSubmitLoading,
      resetUsernameStepContext,
    } = this.props;
    const tabs = [
      {
        key: emailTabLabel,
        label: emailTabLabel,
      },
      {
        key: mobileTabLabel,
        label: mobileTabLabel,
      },
    ];
    const formTitle =
      activedTab === emailTabLabel ? emailFormInputLabel : mobileFormInputLabel;
    const inputEmailProps = {
      type: 'email',
      childrenClassName:
        'customer-reset-usename-container-content-section-form-input-field',
      errorMessage: isEmailEmpty ? emailErrorEmptyMsg : emailErrorMsg,
      placeholder: emailFormInputPlaceholder,
      maxLength: 50,
      mandatory: true,
      onChange: this.onEmailChange,
      onBlur: this.onEmailChange,
    };
    const inputMobileProps = {
      onChange: this.onMobilehange,
      errorMessage: mobileErrorMsg,
      dropdownPlaceholder: t('COUNTRY_TELEPHONE_NUMBER_DROPDOWN_PLACEHOLDER'),
      placeholder: mobileFormInputPlaceholder,
      countryOption: [
        {
          optionVal: '852',
          optionTitle: '852',
        },
        {
          optionVal: '853',
          optionTitle: '853',
        },
        {
          optionVal: '86',
          optionTitle: '86',
        },
        {
          optionVal: '886',
          optionTitle: '886',
        },
      ],
    };
    return isSubmitLoading ? (
      <LoadingView />
    ) : (
      <div className="customer-reset-usename-container">
        <ChangeContactView
          onGoBack={this.onGoBack}
          pageName={title ? resolveLocalizedText(title) : ''}
          stepContext={resetUsernameStepContext}
          activeIndex={0}
        >
          <div className="emma-stylesheet-grid-system">
            <div className="customer-reset-usename-container-desc">{desc}</div>
            <div className="customer-reset-usename-container-content">
              <EmmaTabs
                className="customer-reset-usename-container-content-tabs"
                tabs={tabs}
                value={activedTab}
                onChange={(value) => this.toggleTab(value)}
                divider
                isFullWidthInMobile
              />
              <div className="customer-reset-usename-container-content-section content-align">
                <div className="customer-reset-usename-container-content-section-form">
                  <div className="customer-reset-usename-container-content-section-form-title">
                    {formTitle}
                  </div>
                  <div className="customer-reset-usename-container-content-section-form-input">
                    {activedTab === emailTabLabel && (
                      <InputField {...inputEmailProps} />
                    )}
                    {activedTab === mobileTabLabel && (
                      <CountryTelephoneNumber {...inputMobileProps} />
                    )}
                  </div>
                  <div className="customer-reset-usename-container-content-section-form-button">
                    <div className="content-align">
                      {activedTab === emailTabLabel && (
                        <button
                          className={
                            isEmailCorrect && !isSubmitLoading
                              ? 'emma-stylesheet-primary-default-button'
                              : 'emma-stylesheet-primary-secondary-default-disabled-button'
                          }
                          data-enable-ga={isEmailCorrect && !isSubmitLoading}
                          data-ga-type="button"
                          disabled={!isEmailCorrect || isSubmitLoading}
                          type="submit"
                          onClick={() =>
                            this.onSubmit(RESET_USER_NAME_EMAIL_TYPE)
                          }
                        >
                          {isSubmitLoading && (
                            <img src={loadingIcon} alt="loading" />
                          )}
                          {emailFormInputButtonText}
                        </button>
                      )}
                      {activedTab === mobileTabLabel && (
                        <button
                          className={
                            isMobileCorrect && !isSubmitLoading
                              ? 'emma-stylesheet-primary-default-button'
                              : 'emma-stylesheet-primary-secondary-default-disabled-button'
                          }
                          data-enable-ga={isMobileCorrect && !isSubmitLoading}
                          data-ga-type="button"
                          disabled={!isMobileCorrect || isSubmitLoading}
                          type="submit"
                          onClick={() =>
                            this.onSubmit(RESET_USER_NAME_MOBILE_TYPE)
                          }
                        >
                          {isSubmitLoading && (
                            <img src={loadingIcon} alt="loading" />
                          )}
                          {mobileFormInputButtonText}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ChangeContactView>
        <EmmaErrorModal />
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const resetUsenameLabels = getCustomerProfileUsenameConfig(state);
    const title =
      resetUsenameLabels && resetUsenameLabels.title
        ? resolveLocalizedText(resetUsenameLabels.title)
        : '';
    const desc =
      resetUsenameLabels && resetUsenameLabels.desc
        ? resolveLocalizedText(resetUsenameLabels.desc)
        : '';
    // for email
    const emailLabels = _.get(resetUsenameLabels, `emailLabels`, {});
    const emailTabLabel =
      emailLabels && emailLabels.tabLabel
        ? resolveLocalizedText(emailLabels.tabLabel)
        : '';
    const emailFormLabels = _.get(
      resetUsenameLabels,
      `emailLabels.formLabels`,
      {},
    );
    const emailFormInputLabel =
      emailFormLabels && emailFormLabels.inputLabel
        ? resolveLocalizedText(emailFormLabels.inputLabel)
        : '';
    const emailFormInputPlaceholder =
      emailFormLabels && emailFormLabels.inputPlaceholder
        ? resolveLocalizedText(emailFormLabels.inputPlaceholder)
        : '';
    const emailFormInputButtonText =
      emailFormLabels && emailFormLabels.inputButtonText
        ? resolveLocalizedText(emailFormLabels.inputButtonText)
        : '';
    const emailErrorMsg =
      emailFormLabels && emailFormLabels.emailErrorMsg
        ? resolveLocalizedText(emailFormLabels.emailErrorMsg)
        : '';
    const emailErrorEmptyMsg =
      emailFormLabels && emailFormLabels.emailErrorEmptyMsg
        ? resolveLocalizedText(emailFormLabels.emailErrorEmptyMsg)
        : '';
    // for mobile
    const mobileLabels = _.get(resetUsenameLabels, `mobileLabels`, {});
    const mobileTabLabel =
      mobileLabels && mobileLabels.tabLabel
        ? resolveLocalizedText(mobileLabels.tabLabel)
        : '';
    const mobileFormLabels = _.get(
      resetUsenameLabels,
      `mobileLabels.formLabels`,
      {},
    );
    const mobileFormInputLabel =
      mobileFormLabels && mobileFormLabels.inputLabel
        ? resolveLocalizedText(mobileFormLabels.inputLabel)
        : '';
    const mobileFormInputPlaceholder =
      mobileFormLabels && mobileFormLabels.inputPlaceholder
        ? resolveLocalizedText(mobileFormLabels.inputPlaceholder)
        : '';
    const mobileFormInputButtonText =
      mobileFormLabels && mobileFormLabels.inputButtonText
        ? resolveLocalizedText(mobileFormLabels.inputButtonText)
        : '';
    const mobileErrorMsg =
      mobileFormLabels && mobileFormLabels.mobileErrorMsg
        ? resolveLocalizedText(mobileFormLabels.mobileErrorMsg)
        : '';

    const resetUsernameStepContext =
      resetUsenameLabels && resetUsenameLabels.resetUsernameStepContext
        ? resolveLocalizedText(resetUsenameLabels.resetUsernameStepContext)
        : '';

    const isSubmitLoading = getSendOtpLoading(state);

    const curUpdateKey = getCustomerProfileCurrentUpdateKey(state);

    return {
      title,
      desc,
      emailTabLabel,
      emailFormInputLabel,
      emailFormInputPlaceholder,
      emailFormInputButtonText,
      mobileTabLabel,
      mobileFormInputLabel,
      mobileFormInputPlaceholder,
      mobileFormInputButtonText,
      emailErrorMsg,
      mobileErrorMsg,
      emailErrorEmptyMsg,
      isSubmitLoading,
      curUpdateKey,
      resetUsernameStepContext,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      onSubmitResetUserName: (params: any) =>
        dispatch(submitResetUserName(params)),
      onSendOtp: (params: any) => dispatch(sendOtp(params)),
      onUpdateResetUserNameEmail: (params: string) =>
        dispatch(updateResetUserNameEmail(params)),
      onUpdateResetUserNameMobile: (params: string) =>
        dispatch(updateResetUserNameMobile(params)),
      onChangeCurTab: (params: string) => dispatch(changeCurTab(params)),
    };
  }
}

export default connect(
  CustomerResetUsenameContainer.mapStateToProps,
  CustomerResetUsenameContainer.mapDispatchToProps,
)(CustomerResetUsenameContainer);
